module.exports = __webpack_public_path__ + "img/middle-background.42536f78.png";